// components/Layout/Topbar/LogoutButton.jsx
import React from "react";
import Swal from "sweetalert2";

const LogoutButton = () => {
  const logoutUser = () => {
    Swal.fire({
      title: "Do you want to logout?",
      showDenyButton: true,
      confirmButtonColor: "#01684b",
      cancelButtonColor: "#363636",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        localStorage.removeItem("auth");
        window.location.href = "/";
      } else {
        Swal.fire({
          title: "Canceled",
          confirmButtonText: "Okay",
        });
      }
    });
  };

  return (
    <button
      onClick={logoutUser}
      className="flex  w-full py-3 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
    >
      Sign out
    </button>
  );
};

export default LogoutButton;